import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { Button, ComboBox, useFilter } from 'react-aria-components';
import { ComboInput, ComboList } from './combo-parts.js';
import { cx } from './cx.js';
import { definedProps, fieldRootClassName } from './field-parts.js';
/**
 * One choice out of a long list, found by typing (a combobox, WAI-ARIA): „Düss“ narrows the list
 * to what contains it - in the label or a keyword, regardless of case and accents. The chevron
 * opens the whole list; arrows, Enter and Escape as in every combobox. Only an entry of the list
 * can be chosen: text that is none goes back to the chosen entry when the field is left.
 */
export function SearchSelectField({ label, placeholder, options, value, onChange, description, errorMessage, isRequired, isDisabled, className, }) {
    const { contains } = useFilter({ sensitivity: 'base' });
    const labelOf = (id) => options.find((o) => o.id === id)?.label ?? '';
    const [input, setInput] = useState(() => labelOf(value));
    // A value changed from outside shows its label (React's derived state, no effect).
    const [shown, setShown] = useState(value);
    if (shown !== value) {
        setShown(value);
        setInput(labelOf(value));
    }
    const typed = input.trim();
    const items = typed === '' || input === labelOf(value)
        ? options
        : options.filter((o) => o.always === true || [o.label, ...(o.keywords ?? [])].some((t) => contains(t, typed)));
    return (_jsxs(ComboBox, { items: items, inputValue: input, onInputChange: setInput, selectedKey: value, onSelectionChange: (key) => {
            const chosen = options.find((o) => o.id === key);
            // Left with text that is no entry: back to the one chosen.
            setInput(chosen?.label ?? labelOf(value));
            if (chosen && chosen.id !== value)
                onChange(chosen.id);
        }, ...definedProps({ isRequired, isDisabled }), className: cx('group', fieldRootClassName, className), children: [_jsx(ComboInput, { label: label, placeholder: placeholder, description: description, errorMessage: errorMessage, isRequired: isRequired, end: _jsx(Button, { "aria-label": "Alle anzeigen", className: "grid size-11 cursor-pointer place-items-center rounded-full text-muted outline-none data-focus-visible:ring-2 data-focus-visible:ring-focus", children: _jsx(ChevronDown, { "aria-hidden": true, className: "size-4" }) }) }), _jsx(ComboList, {})] }));
}
//# sourceMappingURL=search-select-field.js.map